import norwegianAirportCodesToDestinationCodesMap from 'static/airlines/norwegianholidays/airportCodesToDestinationCodesMap';

export default function mapNorwegianAirportCodesToDestinationCodes(destinations) {
  return destinations.map((code) => {
    return norwegianAirportCodesToDestinationCodesMap[code] ? norwegianAirportCodesToDestinationCodesMap[code] : code;
  });
}
